module.exports = __webpack_public_path__ + "static/img/normal_u55.c6f7d6f6.svg";